// Typelizer digest d99efa804a3dcd9a7e98af58f61607dd
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../runtime'
import { buildUrl } from '../runtime'

export default {
  /** POST /learners/schools/:school_id/relief_listings/:id/close */
  close: (
    params: { schoolId: string | number; id: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/learners/schools/:school_id/relief_listings/:id/close', params, options),
    method: 'post',
  }),

  /** GET /learners/schools/:school_id/relief_listings */
  index: (
    params: { schoolId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/learners/schools/:school_id/relief_listings', params, options),
    method: 'get',
  }),

  /** POST /learners/schools/:school_id/relief_listings */
  create: (
    params: { schoolId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/learners/schools/:school_id/relief_listings', params, options),
    method: 'post',
  }),

  /** GET /learners/schools/:school_id/relief_listings/new */
  new: (
    params: { schoolId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/learners/schools/:school_id/relief_listings/new', params, options),
    method: 'get',
  }),
}
